import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { correctCircle } from '../../assets'
import { Modal } from "react-bootstrap";
import GenAIAnsweringPreview from "../Preview/GenAIAnsweringPreview"
import { clone } from 'underscore'
import { GenAIAnsweringContext } from './GenAIAnsweringContextProvider';
import AlertMessagePopUpModal from "../PopUp/AlertMessagePopUpModal";
import ConfirmMessagePopUpModal from "../PopUp/ConfirmMessagePopUpModal";
import NotebookListPopUp from "../PopUp/NotebookListPopUp";
// import { sanitize } from 'dompurify';
import DOMPurify from "dompurify";
const sanitize = DOMPurify.sanitize;

const ReactNone = 'None';

class GenAIAuthoring2ResultIndex extends Component {
    static contextType = GenAIAnsweringContext;
    constructor(props) {
        // this.messagesEndRef = createRef()
        super(props);
        this.state = {
            customWidth: props.customWidth,
            customHeight: props.customHeight,
            Question: props.Question,
            OutputAnswer: props.OutputAnswer,
            // Sources: props.Sources,
            // DisplayString: props.DisplayString,
            RecommandationResults: props.RecommandationResults,
            isShowMore: false,
            selectedSource: null,
            selectedPageNumber: [],
            showPreviewModel: false,
            isInEditMode: false,
            updatedQuestion: props.Question,
            conversationIndex: props.conversationIndex,
            eventid: props.eventid,
            isMultiFiles: props.isMultiFiles,
            DisplayStringMultiFiles: props.DisplayStringMultiFiles,
            SourcesMultiFiles: props.SourcesMultiFiles,
            attachedFiles: props.attachedFiles,
            CombinedSummaryMultiFiles: props.CombinedSummaryMultiFiles,
            displayFilters: {},
            dtDropDownCollapsed: false,
            reaction: props.reaction ? props.reaction : ReactNone,
            feedback: props.feedback ? props.feedback : '',
            currentFeedback: props.feedback ? props.feedback : '',
            isComprehensive: props.isComprehensive ? clone(props.isComprehensive) : false,
            isFeedbackProcessing: false,
            isReactProcessing: false,
            isClickOnReportAns: false,
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
            isCopiedAns: false,
            confirmMessageContent: '',
            confirmMessageShowModal: false,
            confirmMessageId: -1,
            lastCreatedDatehour: props.lastCreatedDatehour,
            RelevantInformation: props.RelevantInformation,
            ShowRelevantInformation: props.ShowRelevantInformation,
            threadAttachedFiles: (props.threadAttachedFiles && props.threadAttachedFiles.length > 0) ? clone(props.threadAttachedFiles) : [],
            isImageThread: props.isImageThread,
            savingSummarizeText: '',
            savingCommandType: 'QnA',
            savingOrignalText: '',
            savingCommandText: '',
            savingReference: '',
            showNotebookList: false,
            selectedReadingLevel: (props.readingLevel) ? clone(props.readingLevel) : "",
            readingLevel: ["8", "9", "10", "12"],
            wordLimit: (props.wordLimit) ? clone(props.wordLimit) : "",
            updatedReadingLevel: "",
            updatedWordLimit: "",
            errorMsg: ""
        }
    }
    componentDidMount() {

    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.attachedFiles.length !== this.props.attachedFiles.length) {
            this.setState({ attachedFiles: nextProps.attachedFiles });
        }
        if (nextProps.lastCreatedDatehour !== this.props.lastCreatedDatehour) {
            this.setState({ lastCreatedDatehour: nextProps.lastCreatedDatehour });
        }
        if (nextProps.ShowRelevantInformation !== this.props.ShowRelevantInformation) {
            this.setState({ ShowRelevantInformation: nextProps.ShowRelevantInformation });
        }

        if (nextProps.reaction !== this.props.reaction) {
            this.setState({ reaction: nextProps.reaction });
        }
        if (nextProps.feedback !== this.props.feedback) {
            this.setState({ feedback: nextProps.feedback, currentFeedback: nextProps.feedback });
        }
        if (nextProps.isComprehensive !== this.props.isComprehensive) {
            this.setState({ isComprehensive: clone(nextProps.isComprehensive) });
        }
        if (nextProps.readingLevel !== this.props.readingLevel) {
            this.setState({ selectedReadingLevel: clone(nextProps.readingLevel) });
        }
        if (nextProps.wordLimit !== this.props.wordLimit) {
            this.setState({ wordLimit: clone(nextProps.wordLimit) });
        }
    }
    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#00c12c",
            alertMessageShowModal: true
        })
    }
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#de1327",
            alertMessageShowModal: true
        })
    }
    closeAlertMessage = () => {
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            alertMessageShowModal: false,
            showPreview: false
        })
    }
    showConfirmMessage = (message, id) => {
        this.setState({
            confirmMessageContent: message,
            confirmMessageShowModal: true,
            confirmMessageId: id
        })
    }

    confirmHandler = async () => {
        this.setState(
            {
                confirmMessageContent: "",
                confirmMessageShowModal: false,
                // confirmMessageId: -1
            },
            async () => {
                let { Question, conversationIndex, eventid, wordLimit, selectedReadingLevel } = this.state;
                await this.props.updateRunGenAISearch(Question, conversationIndex, eventid, wordLimit, selectedReadingLevel);
            }
        );
    }

    closeConfirmMessage = () => {
        this.setState({
            confirmMessageContent: "",
            confirmMessageShowModal: false,
            confirmMessageIndex: -1
        })
    }


    renderModelPopup() {
        const { showPreviewModel, selectedSource, selectedPageNumber, attachedFiles, isMultiFiles } = this.state;
        return (<Modal
            show={showPreviewModel}
            size="xl"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="answering-popup-transition"
            className="z-index-preview"
            backdropClassName="z-index-preview-backdrop"
            scrollable={false}>
            <Modal.Body>
                <div style={{ overflow: "auto" }}>
                    <GenAIAnsweringPreview selectedSource={selectedSource}
                        selectedPageNumber={selectedPageNumber}
                        attachedFiles={attachedFiles}
                        isMultiFiles={isMultiFiles}
                        handleClose={this.handlePreviewClose} />
                </div>
            </Modal.Body>
        </Modal>)
    }

    handlePreviewClose = async () => {
        this.setState({ showPreviewModel: false },
            async () => {
                setTimeout(() => {
                    document.body.classList.remove('custome-modal-open');
                }, 1000);
            })
    }






    snippetLongStringForKeyword = (snippet, strLength = 35) => {
        if (snippet.length > strLength) {
            let text = snippet.substring(0, strLength)//cuts to 70
            text = text + `...`//adds (...) at the end to show that it's cut
            return text
        }
        return snippet;
    }


    handleEditReading = (e) => {
        this.setState({
            updatedReadingLevel: e.target.value,
        })
    }
    handleWordLimit = (e) => {
        this.setState({
            updatedWordLimit: e.target.value
        })
    }
    handleClickOnEditQuestion = () => {
        this.setState({
            isInEditMode: !this.state.isInEditMode,
            updatedQuestion: this.state.Question,
            updatedReadingLevel: this.state.selectedReadingLevel,
            updatedWordLimit: this.state.wordLimit,
        }, () => {
            this.scrollToBottom();
        })
    }
    handleClickOnRewriteAnswer = () => {
        this.showConfirmMessage("Are you sure you want to refresh the answer?", "")
    }





    renderDisplayStringMultiFiles = () => {
        let { SourcesMultiFiles, DisplayStringMultiFiles, OutputAnswer, eventid, threadAttachedFiles } = this.state;
        if (DisplayStringMultiFiles.length > 0) {
            let isNoAnswerFound = DisplayStringMultiFiles.every(x => x.display_ans === "No answer found in this document");
            if (isNoAnswerFound) {
                return (<div className="gen-ai-answering-result-main-answer-wrapper" id={`resultMainAnswer${eventid}`}>
                    <span dangerouslySetInnerHTML={{ __html: sanitize("No answer found in this document.") }} />
                </div>)
            }
            else {
                return (<div className="gen-ai-answering-result-main-answer-wrapper" id={`resultMainAnswer${eventid}`}>{
                    SourcesMultiFiles.map((smitem, smindex) => {
                        let filterDisplayStringMultiFiles = DisplayStringMultiFiles.filter(x => x.source_no.includes(smindex + 1));
                        let isImageUpload = threadAttachedFiles.some(x =>
                            x.name.toLowerCase().endsWith('.gif')
                            || x.name.toLowerCase().endsWith('.jpeg')
                            || x.name.toLowerCase().endsWith('.jpg')
                            || x.name.toLowerCase().endsWith('.png'))
                        if (isImageUpload) {
                            filterDisplayStringMultiFiles = DisplayStringMultiFiles;
                        }
                        return (<>
                            {
                                filterDisplayStringMultiFiles.filter(x => x.display_ans !== "No answer found in this document").map((dsitem, dsindex) => {
                                    if (!isImageUpload) {
                                        //dsitem.display_ans = dsitem.display_ans.replace(/<br\/>/g, '').replace(/<br>/g, '')
                                        dsitem.display_ans = dsitem.display_ans.replace(/<li><br>/g, '<li>');
                                    }
                                    let dsitemDisplayAns = dsitem.display_ans;
                                    if (smindex !== 0) {
                                        dsitemDisplayAns = `<br/>${dsitemDisplayAns}`
                                    }
                                    return (<span dangerouslySetInnerHTML={{ __html: sanitize(`${dsitemDisplayAns}`) }} />)
                                })
                            }

                        </>)
                    })
                }</div>)
            }

        } else {

            if (OutputAnswer === "We don't know the answer. Can you try new questions.") {
                OutputAnswer = `No Answer found. Please try a new question.`;
            }
            return (<div className="gen-ai-answering-result-main-answer-wrapper" id={`resultMainAnswer${eventid}`}>
                {OutputAnswer}
            </div>)



        }
    }

    handleEditQuestion = (e) => {
        this.setState({ updatedQuestion: e.target.value })
    }
    handleClickOnCancelEditQuestion = (e) => {
        this.setState({
            isInEditMode: false,
            updatedQuestion: this.state.Question
        })
    }
    handleValidation = (value) => {
        let errors = {};
        let isValid = true;
        if (!value || Number.isNaN(parseInt(value))) {
            errors['wordLimit'] = '*Please enter a numeric value.'
            isValid = false
        }
        else if (value < 50) {
            errors['wordLimit'] = '*Please select word limit greater than 50.'
            isValid = false
        }
        this.setState({ errorMsg: errors })
        return (isValid)

    }
    handleClickOnSaveEditQuestion = async (e) => {
        let { updatedQuestion, conversationIndex, eventid, updatedWordLimit, updatedReadingLevel } = this.state;
        if (this.handleValidation(updatedWordLimit)) {
            await this.props.updateRunGenAISearch(updatedQuestion, conversationIndex, eventid, updatedWordLimit, updatedReadingLevel);
            this.setState({
                isInEditMode: false,
            })
        }
    }
    scrollToBottom = () => {
        this.messagesEndRef.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
    }

    generateArrayString = (array) => {
        let arrStr = ''
        array.map((item, index) => {
            if (index === array.length - 1) {
                arrStr += item
            }
            else {
                arrStr += item + ";"
            }
            return null
        })
        return arrStr
    }


    handleClickOnCopyAns = () => {
        let { eventid } = this.state;
        let _allSup = document.querySelectorAll(`#resultMainAnswer${eventid} .gen-ai-answering-result-main-answer-sup`);
        let _allFileIcon = document.querySelectorAll(`#resultMainAnswer${eventid} .gen-ai-answering-result-main-answer-display-string-multi-files-document-title > b > img`);
        if (_allSup && _allSup.length > 0) {
            for (let i = 0; i < _allSup.length; i++) {
                _allSup[i].style.visibility = "hidden"
            }
        }
        if (_allFileIcon && _allFileIcon.length > 0) {
            for (let i = 0; i < _allFileIcon.length; i++) {
                _allFileIcon[i].style.display = "none"
            }
        }
        const textLayers = document.querySelector(`#resultMainAnswer${eventid}`)
        document.getElementsByClassName('gen-ai-answering-result-main-answer-sup')

        if (window.getSelection) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(textLayers);
            selection.removeAllRanges();
            selection.addRange(range);
        }
        document.execCommand('copy', true);
        if (window.getSelection) {
            window.getSelection().removeAllRanges();
        }
        else if (document.selection) {
            document.selection.empty();
        }
        if (_allSup && _allSup.length > 0) {
            for (let i = 0; i < _allSup.length; i++) {
                _allSup[i].style.visibility = "visible"
            }
        }
        if (_allFileIcon && _allFileIcon.length > 0) {
            for (let i = 0; i < _allFileIcon.length; i++) {
                _allFileIcon[i].style.display = "inline"
            }
        }

        this.setState({ isCopiedAns: true }, () => {
            setTimeout(async () => {
                this.setState({ isCopiedAns: false });
            }, 3000);
        })
        // let { OutputAnswer, SourcesMultiFiles, DisplayStringMultiFiles, isMultiFiles, RelevantInformation, threadAttachedFiles } = this.state;
        // let _textDisplayString = '';
        // try {
        //     if (isMultiFiles) {
        //         let _displayStringMultiFiles = clone(this.state.DisplayStringMultiFiles);
        //         if (_displayStringMultiFiles.length > 0) {
        //             SourcesMultiFiles.map((smitem, smindex) => {
        //                 let filterDisplayStringMultiFiles = _displayStringMultiFiles.filter(x => x.source_no.includes(smindex + 1));
        //                 let isImageUpload = threadAttachedFiles.some(x =>
        //                     x.name.toLowerCase().endsWith('.gif')
        //                     || x.name.toLowerCase().endsWith('.jpeg')
        //                     || x.name.toLowerCase().endsWith('.jpg')
        //                     || x.name.toLowerCase().endsWith('.png'))
        //                 if (isImageUpload) {
        //                     filterDisplayStringMultiFiles = DisplayStringMultiFiles;
        //                 }
        //                 _textDisplayString += `File: ${smitem.document_title}\n`;
        //                 filterDisplayStringMultiFiles.map((dsitem, dsindex) => {
        //                     let _dsItem = clone(dsitem)
        //                     _dsItem.display_ans = _dsItem.display_ans.replace(/<li><br>/g, '<li>');
        //                     if (isImageUpload) {
        //                         _dsItem.display_ans = _dsItem.display_ans.replace(/<br\/>/g, '\n').replace(/<br>/g, '\n')
        //                     } else {
        //                         _dsItem.display_ans = _dsItem.display_ans.replace(/<br\/>/g, '').replace(/<br>/g, '')
        //                     }
        //                     _dsItem.display_ans = _dsItem.display_ans.replace(/<li>/g, '\n- <li>');
        //                     let regex = /<\/ul>/i;
        //                     _dsItem.display_ans = _dsItem.display_ans.replace(regex, '</ul>');
        //                     _textDisplayString += _dsItem.display_ans.replace(/(<([^>]+)>)/ig, '')
        //                     if (_dsItem.context_id && Array.isArray(_dsItem.context_id)) {
        //                         _dsItem.context_id.map((ctitem, ctindex) => {
        //                             let _sourceIndex = SourcesMultiFiles.filter(x => x.contexts).findIndex(x => x.contexts.findIndex(y => y.context_id === ctitem) !== -1);
        //                             if (_sourceIndex > -1) {
        //                                 _textDisplayString += `[${ctitem}]`

        //                             } else {
        //                                 _textDisplayString += `[${ctitem}]`
        //                             }
        //                         })
        //                         _textDisplayString += `\n`;
        //                     }
        //                 })
        //                 _textDisplayString += "\n\n"
        //             })
        //             _textDisplayString += "Sources\n"
        //             SourcesMultiFiles.map((conversation, conversationIndex) => {
        //                 if ((conversation.contexts && conversation.contexts.length > 0)) {
        //                     conversation.contexts = conversation.contexts.sort((a, b) => a.context_id - b.context_id);
        //                 }
        //                 _textDisplayString += `${conversationIndex + 1}. Document Name: ${conversation.document_title}\n`
        //                 conversation.contexts.map((conItem, consIndex) => {
        //                     let _displayStringFilter = DisplayStringMultiFiles.filter(x => x.context_id && x.context_id.includes(conItem.context_id));
        //                     if (_displayStringFilter.length > 0) {
        //                         let _displayStringSingle = _displayStringFilter[0];
        //                         let displayIndex = _displayStringSingle.context_id.findIndex(x => x === conItem.context_id);

        //                         _textDisplayString += `Citation: [${conItem.context_id}], Pages No: [${[_displayStringSingle.page_number[displayIndex]].join(',')}]\n`

        //                     } else {
        //                         _textDisplayString += `Citation: [${conItem.context_id}]\n`
        //                     }
        //                 })
        //             })
        //         } else {
        //             if (OutputAnswer === "We don't know the answer. Can you try new questions.") {
        //                 OutputAnswer = `No Answer found. Please try a new question.`;
        //             }
        //             _textDisplayString = OutputAnswer;
        //         }
        //     } else {
        //         Object.keys(RelevantInformation).map((RIItem, RIIndex) => {
        //             let { DisplayString, Sources } = RelevantInformation[RIItem];
        //             let _displayString = clone(DisplayString);
        //             if (_displayString.length > 0) {
        //                 _displayString.map((dsitem, dsindex) => {
        //                     let _dsItem = clone(dsitem)
        //                     _dsItem.display_ans = _dsItem.display_ans.replace(/<li><br>/g, '<li>');
        //                     _dsItem.display_ans = _dsItem.display_ans.replace(/<br\/>/g, '').replace(/<br>/g, '')
        //                     _dsItem.display_ans = _dsItem.display_ans.replace(/<li>/g, '\n- <li>');
        //                     let regex = /<\/ul>/i;
        //                     _dsItem.display_ans = _dsItem.display_ans.replace(regex, '</ul>');
        //                     _textDisplayString += _dsItem.display_ans.replace(/(<([^>]+)>)/ig, '')
        //                     _dsItem.source_no.map((sitem, dsindex) => {
        //                         let _sourceIndex = Sources.filter(x => x.contexts).findIndex(x => x.contexts.findIndex(y => y.context_id === sitem) !== -1);
        //                         if (_sourceIndex > -1) {
        //                             let singleSource = Sources.filter(x => x.contexts)[_sourceIndex];
        //                             _textDisplayString += `[${sitem}]`
        //                         } else {
        //                             _textDisplayString += `[${sitem}]`
        //                         }
        //                     })
        //                     _textDisplayString = _textDisplayString.trim();
        //                     _textDisplayString += '\n';
        //                 })
        //                 _textDisplayString += "\n"
        //                 _textDisplayString += "Sources\n"
        //                 Sources.map((conversation, conversationIndex) => {
        //                     let { context_id, context, document_title, section_id, download_url, doc_number, contexts, enclosureDocID } = conversation;
        //                     if (enclosureDocID && enclosureDocID.toString().trim()) {
        //                         download_url += `&enclosureID=${enclosureDocID}`
        //                     }
        //                     if ((conversation.contexts && conversation.contexts.length > 0)) {
        //                         conversation.contexts = conversation.contexts.sort((a, b) => a.context_id - b.context_id);
        //                     }
        //                     _textDisplayString += `${conversationIndex + 1}. Document Name: ${document_title}\n`
        //                     _textDisplayString += `Document URL: ${_locationOrigin}${download_url}\n`
        //                     conversation.contexts.map((conItem, consIndex) => {
        //                         let _displayStringFilter = DisplayString.filter(x => x.source_no.includes(conItem.context_id));
        //                         if (_displayStringFilter.length > 0) {
        //                             let _displayStringSingle = _displayStringFilter[0];
        //                             let displayIndex = _displayStringSingle.source_no.findIndex(x => x === conItem.context_id);
        //                             _textDisplayString += `Citation: [${conItem.context_id}], Pages No: [${_displayStringSingle.page_number[displayIndex].join(',')}]\n`
        //                         } else {
        //                             _textDisplayString += `Citation: [${conItem.context_id}]\n`
        //                         }
        //                     })
        //                     _textDisplayString += "\n"
        //                 })
        //             } else {
        //                 if (RIIndex === 0) {
        //                     _textDisplayString += `No Answer found. Please try a new question.\n`
        //                 } else {
        //                     _textDisplayString += `No more information found.\n`
        //                 }
        //             }
        //             _textDisplayString += "____________________________________________________________________________\n"
        //         })

        //     }
        //     navigator.clipboard.writeText(_textDisplayString).then(() => {
        //         this.setState({ isCopiedAns: true }, () => {
        //             setTimeout(async () => {
        //                 this.setState({ isCopiedAns: false });
        //             }, 3000);
        //         })
        //     })
        // } catch (error) {
        //     console.log(error)
        //     this.errorAlertMessage("Sorry, something went wrong.");
        // }
    }



    handleAddToNotebook = () => {
        let _summarizeText = this.QnAResultChatConversation();
        let _savingReference = this.QnAReference();
        let _commandText = this.state.Question;
        this.setState({
            savingSummarizeText: _summarizeText,
            savingCommandType: 'QnA',
            savingOrignalText: '',
            savingCommandText: _commandText,
            savingReference: _savingReference,
            showNotebookList: true
        })
    }

    handleCloseNotebookList = () => {
        this.setState({ showNotebookList: false, showNotebookPreviewList: false, isFromGlobalFeaturesMenuForNotebook: false });
    }

    QnAResultChatConversation = () => {
        let { OutputAnswer, SourcesMultiFiles } = this.state;
        let _textDisplayString = '';
        try {

            let _displayStringMultiFiles = clone(this.state.DisplayStringMultiFiles);
            if (_displayStringMultiFiles && _displayStringMultiFiles.length > 0) {
                SourcesMultiFiles.forEach((smitem, smindex) => {
                    let filterDisplayStringMultiFiles = _displayStringMultiFiles.filter(x => x.source_no.includes(smindex + 1));

                    filterDisplayStringMultiFiles.forEach((dsitem, dsindex) => {
                        let _dsItem = clone(dsitem)
                        _dsItem.display_ans = _dsItem.display_ans.replace(/<li><br>/g, '<li>');
                        _dsItem.display_ans = _dsItem.display_ans.replace(/<sup><b style='background-color:lightblue'>\s\s<\/b><\/sup/g, '');
                        // if (isImageUpload) {
                        //     _dsItem.display_ans = _dsItem.display_ans.replace(/<br\/>/g, '\n').replace(/<br>/g, '\n')
                        // } else {
                        //     _dsItem.display_ans = _dsItem.display_ans.replace(/<br\/>/g, '').replace(/<br>/g, '')
                        // }
                        // _dsItem.display_ans = _dsItem.display_ans.replace(/<li>/g, '\n- <li>');
                        // let regex = /<\/ul>/i;
                        // _dsItem.display_ans = _dsItem.display_ans.replace(regex, '</ul>');
                        // _textDisplayString += _dsItem.display_ans.replace(/(<([^>]+)>)/ig, '')
                        _textDisplayString += _dsItem.display_ans;
                        _textDisplayString += '<br>';
                        _textDisplayString = _textDisplayString.replace(/<\/li><br>/g, '</li>');
                    })
                })
            } else {
                if (OutputAnswer === "We don't know the answer. Can you try new questions.") {
                    OutputAnswer = `No Answer found. Please try a new question.`;
                }
                _textDisplayString = OutputAnswer;
            }


            return _textDisplayString;

        } catch (error) {
            console.log(error)

        }
        return _textDisplayString;
    }

    QnAReference = () => {
        let { OutputAnswer, SourcesMultiFiles } = this.state;
        let _textDisplayString = '';
        try {

            let _displayStringMultiFiles = clone(this.state.DisplayStringMultiFiles);
            if (_displayStringMultiFiles && _displayStringMultiFiles.length > 0) {
                SourcesMultiFiles.forEach((conversation, conversationIndex) => {
                    if ((conversation.contexts && conversation.contexts.length > 0)) {
                        conversation.contexts = conversation.contexts.sort((a, b) => a.context_id - b.context_id);
                    }
                    _textDisplayString += `${conversationIndex + 1}. Document Name: ${conversation.document_title}\n`
                })
            } else {
                if (OutputAnswer === "We don't know the answer. Can you try new questions.") {
                    OutputAnswer = `No Answer found. Please try a new question.`;
                }
                _textDisplayString = OutputAnswer;
            }


        } catch (error) {
            console.log(error)
            this.errorAlertMessage("Sorry, something went wrong.");
        }
        return _textDisplayString;
    }
    render() {
        let { Question, isInEditMode, updatedQuestion } = this.state;
        const { alertMessageModelColor, alertMessageContent, alertMessageShowModal, isCopiedAns } = this.state;
        const { confirmMessageContent, confirmMessageShowModal, showNotebookList } = this.state;
        const { savingSummarizeText, savingCommandType, savingOrignalText, savingCommandText, savingReference } = this.state;
        let isDisable = (Question === updatedQuestion && this.state.updatedReadingLevel === this.state.selectedReadingLevel && this.state.updatedWordLimit === this.state.wordLimit);
        if (this.state.customWidth >= 600 && this.state.customWidth <= 1000) {
            return (<></>)
        }
        else if (this.state.customWidth > 1000) {
            return (<> <div className="gen-ai-answering-result-main">
                <div ref={(el) => { this.messagesEndRef = el; }} style={{ marginTop: "-50px" }}>&nbsp;</div>
                <div className="gen-ai-authoring2-result-left">
                    {isInEditMode ?
                        <div className="gen-ai-answering-result-update-question">
                            <div className="gen-ai-answering-result-update-question-textarea-section">
                                <textarea placeholder="" className="" onChange={(e) => this.handleEditQuestion(e)} value={updatedQuestion} />
                            </div>
                            <div className="gen-ai-answering-result-update-question-control">
                                {/*(!isMultiFiles) && <div className="gen-ai-answering-main-action-section-comprehensive"><b>Comprehensive Answer</b>&nbsp;<ToggleSwitch key={`gen-ai-search-toggle-${this.props.conversationIndex}`} customKey={`gen-ai-search-toggle-${this.props.conversationIndex}`} isComprehensive={isComprehensive} handleOnChangeToggleSwitch={this.handleOnChangeToggleSwitch} /></div>*/}
                                <div className="GenAIAuthoring-main-readinglevel-create-draf-container" style={{ justifyContent: 'flex-start' }}>
                                    <div className='GenAIAuthoring-main-prompt-reading-level-container' style={{ flexDirection: 'row' }}>
                                        <div className="GenAIAuthoring-div-label GenAIAuthoring-main-prompt-reading-level-label">Reading Level: </div>
                                        {/*<div className="user-prompt-word-limit" style={{ marginLeft : '0px'}}>100</div>*/}
                                        <select
                                            className="user-prompt-word-limit mx-0 wd-140 pd-2"
                                            onChange={(e) => { this.handleEditReading(e) }}
                                            value={this.state.updatedReadingLevel}>
                                            <option value=''>No Reading Level</option>
                                            {this.state.readingLevel.map((val) => {
                                                return <option value={val}>{val}th grade</option>
                                            })}
                                        </select>
                                    </div>
                                    <div className='GenAIAuthoring-main-prompt-reading-level-container' style={{ flexDirection: 'row' }}>
                                        <div className="GenAIAuthoring-div-label GenAIAuthoring-main-prompt-reading-level-label">Word Limit: </div>
                                        {/*<div className="user-prompt-word-limit" style={{ marginLeft : '0px'}}>100</div>*/}
                                        <input className="user-prompt-word-limit mx-0" style={{ textAlign: 'center', padding: '0px' }} type="text" value={this.state.updatedWordLimit} onChange={(e) => { this.handleWordLimit(e) }} />
                                        <div className="errorInvalidName" style={{ fontSize: '10px', marginLeft: "25px", fontWeight: "800" }}>{this.state.errorMsg['wordLimit']}</div>
                                    </div>
                                </div>
                                <button onClick={this.handleClickOnCancelEditQuestion} type="button" className="gen-ai-answering-result-update-question-cancel">
                                    Cancel
                                </button>
                                <button type="button" onClick={this.handleClickOnSaveEditQuestion} disabled={isDisable} className="gen-ai-answering-result-update-question-save">
                                    Save
                                </button>

                            </div>
                        </div>
                        : <><div className="gen-ai-answering-result-question">
                            <h2 className="gen-ai-answering-result-question-h2">{Question}</h2>
                            <div className="gen-ai-answering-result-question-control-section">
                                <button type="button" onClick={this.handleClickOnEditQuestion} className="gen-ai-answering-result-main-answer-control-edit" title="Rewrite" data-state="closed">
                                    <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="pen-to-square" className="svg-inline--fa fa-pen-to-square fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path fill="currentColor" d="M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z">
                                        </path>
                                    </svg>
                                    Rewrite
                                </button>
                                <button type="button" onClick={this.handleClickOnRewriteAnswer} className="gen-ai-answering-result-main-answer-control-rewrite" title="Refresh Answer" data-state="closed">
                                    <svg height="18px" width="16px" className="feather feather-repeat" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <polyline points="17 1 21 5 17 9" />
                                        <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                        <polyline points="7 23 3 19 7 15" />
                                        <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                    Refresh
                                </button>
                            </div>
                        </div>
                        </>}



                    <><div className="gen-ai-answering-result-main-answer-main">
                        <div className="gen-ai-answering-result-main-answer-header">
                            <div className="gen-ai-answering-result-main-answer-header-icon">
                                <img src={correctCircle} alt="Loading Data" style={{ width: "24px" }} />
                            </div>
                            <div className="gen-ai-answering-result-main-answer-header-title">Summary</div>
                            <button title={isCopiedAns ? "Copied" : "Copy to Clipboard"} style={isCopiedAns ? { backgroundColor: "green" } : {}} className={isCopiedAns ? "gen-ai-answering-result-main-answer-control-copied" : "gen-ai-answering-result-main-answer-control-copy"} onClick={e => !isCopiedAns ? this.handleClickOnCopyAns() : () => { }}>
                                {isCopiedAns ? <>
                                    <svg aria-hidden="true" width="15px" height="15px" focusable="false" data-prefix="far" data-icon="clipboard" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 335.765 335.765">
                                        <g>
                                            <g>
                                                <polygon fill="#ffffff" points="311.757,41.803 107.573,245.96 23.986,162.364 0,186.393 107.573,293.962 335.765,65.795 	" />
                                            </g>
                                        </g>
                                    </svg>
                                    &nbsp;
                                    <span style={{ color: "#ffffff" }}>Copied</span>
                                </>
                                    :
                                    <> <svg width="15px" height="15px" aria-hidden="true" focusable="false" data-prefix="far" data-icon="clipboard" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                        <path fill="currentColor" d="M280 64h40c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h40 9.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H280zM64 112c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H304v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112H64zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"></path>
                                    </svg>
                                        &nbsp;
                                        Copy to Clipboard
                                    </>
                                }
                            </button>
                            <button title='Add to Notebook' className="gen-ai-answering-result-main-answer-control-add-to-notebook" onClick={e => this.handleAddToNotebook()}>
                                <svg width="15px" height="15px" aria-hidden="true" focusable="false" data-prefix="far" data-icon="book" className="svg-inline--fa fa-book fa-fw " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" version="1.1">
                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <path d="M26.536 0h-19.937c-1.438 0-2.063 1.063-2.063 2.063v3.979h-1.091c-0.541 0-0.979 0.439-0.979 0.98s0.438 0.98 0.979 0.98h1.091v4.024h-0.998c-0.541 0-0.98 0.438-0.98 0.979s0.438 0.98 0.979 0.98h0.998v4.045h-1.019c-0.541 0-0.979 0.439-0.979 0.98s0.438 0.98 0.979 0.98h1.019v4.014h-1.019c-0.541 0-0.979 0.439-0.979 0.98s0.438 0.98 0.979 0.98h1.019v4.040c0 1.657 1.298 2 2.016 2h19.985c1.657 0 3-1.343 3-3v-26c0-1.657-1.343-3-3-3zM6.535 30l-0-4.040h1.042c0.541 0 0.979-0.439 0.979-0.98s-0.438-0.98-0.979-0.98h-1.042v-4.014h1.042c0.541 0 0.979-0.439 0.979-0.98s-0.438-0.98-0.979-0.98h-1.042v-4.045h1.063c0.541 0 0.98-0.438 0.98-0.98s-0.438-0.979-0.979-0.979h-1.063v-4.024h0.97c0.541 0 0.979-0.439 0.979-0.979s-0.438-0.98-0.979-0.98h-0.97v-3.978c0-0.023 0.002-0.043 0.005-0.060 0.016-0.001 0.035-0.002 0.059-0.002h15.938v28h-16.001zM27.536 29c0 0.552-0.448 1-1 1h-2v-28h2c0.552 0 1 0.448 1 1v26z"></path>
                                    </g>
                                </svg>
                                &nbsp;
                                Add to Notebook
                            </button>
                        </div>
                        {this.renderDisplayStringMultiFiles()}
                    </div>
                    </>

                </div >
            </div >
                {this.renderModelPopup()}
                {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} btnText="Yes" />}
                {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                {showNotebookList && <NotebookListPopUp showModal={showNotebookList} sourceItem={{}} summeryText={savingOrignalText}
                    summarizeText={savingSummarizeText} handleClose={this.handleCloseNotebookList} width={this.props.customWidth}
                    commandType={savingCommandType} commandText={savingCommandText} notesText={''} citationText={savingReference} />
                }
            </>)
        }
    }
}
export default withRouter(GenAIAuthoring2ResultIndex);